var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevicesbluecheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "113px",
    viewBox: "0 0 68 113",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Verification-Code",
    transform: "translate(-1073.000000, -219.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(960.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(114.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4627246,54.4371566 L26.7329021,64.7073341",
    id: "Line",
    stroke: "#158CCC",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6953177,40.7180526 L27.0942144,65.3418265",
    id: "Line",
    stroke: "#158CCC",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(0.109000, 0.000000)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9938735,110.951916 L13.2773105,110.951916 C5.96615322,110.951916 0.0384561983,105.108954 0.0384561983,97.9023073 L0.0384561983,13.0798486 C0.0384561983,5.87320203 5.96615322,0.0302395905 13.2773105,0.0302395905 L52.9938735,0.0302395905 C60.3050308,0.0302395905 66.2327278,5.87320203 66.2327278,13.0798486 L66.2327278,97.9023073 C66.2327278,105.108954 60.3050308,110.951916 52.9938735,110.951916 Z",
    id: "Stroke-1",
    stroke: "#000000",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4453056,97.9023073 C36.4453056,99.7031534 34.9625539,101.16471 33.135592,101.16471 C31.3086301,101.16471 29.8258784,99.7031534 29.8258784,97.9023073 C29.8258784,96.1014613 31.3086301,94.6399051 33.135592,94.6399051 C34.9625539,94.6399051 36.4453056,96.1014613 36.4453056,97.9023073 Z",
    id: "Stroke-3",
    stroke: "#26356C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5161649,9.81744636 L39.7550192,9.81744636",
    id: "Stroke-5",
    stroke: "#26356C",
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesbluecheckmark);
export default __webpack_public_path__ + "static/media/devicesbluecheckmark.67c9a71f1e50d43f62a902bf2bda6c9c.svg";
export { ForwardRef as ReactComponent };